import { map } from "lodash";

// ── clases base ──────────────────────────────────────────────────────────────
const thBase = "px-4 py-3 text-left text-xs font-semibold uppercase tracking-wide text-gray-500 dark:text-gray-400 bg-gray-50 dark:bg-gray-800 border-b border-gray-200 dark:border-gray-700 whitespace-nowrap";
const tdBase = "px-4 py-3 text-sm border-b border-gray-100 dark:border-gray-700 align-middle";

export function FragmentTableUser({ users, updateUser, onDeleteUser, addPpe }) {
    if (!users || users.length === 0) {
        return (
            <div className="py-16 text-center">
                <div className="inline-flex items-center justify-center h-14 w-14 rounded-full bg-gray-100 dark:bg-gray-700 mb-4">
                    <i className="fas fa-users text-gray-400 dark:text-gray-500 text-2xl"></i>
                </div>
                <p className="text-sm font-medium text-gray-500 dark:text-gray-400">No hay empleados registrados</p>
            </div>
        );
    }

    return (
        <div className="overflow-x-auto bg-white dark:bg-gray-900">
            <table className="min-w-full text-sm border-separate border-spacing-0">
                <thead className="sticky top-0 z-10">
                    <tr>
                        <th className={`${thBase} text-center w-14`}>#</th>
                        <th className={`${thBase} text-center`}>Documento</th>
                        <th className={thBase}>Empleado</th>
                        <th className={thBase}>Apellidos</th>
                        <th className={`${thBase} text-center`}>Rol</th>
                        <th className={`${thBase} text-center`}>Ruta principal</th>
                        <th className={`${thBase} text-center`}>Rutas asignadas</th>
                        <th className={`${thBase} text-center`}>Super usuario</th>
                        <th className={`${thBase} text-center`}>Estado</th>
                        <th className={`${thBase} text-center`}>Celular</th>
                        <th className={`${thBase} text-center`}>Acciones</th>
                    </tr>
                </thead>
                <tbody>
                    {map(users, (user, index) => (
                        <tr key={index} className="hover:bg-gray-50 dark:hover:bg-gray-800/50 transition-colors">

                            {/* Código */}
                            <td className={`${tdBase} text-center`}>
                                <span className="inline-block rounded-md bg-gray-100 dark:bg-gray-700 text-gray-700 dark:text-gray-300 text-xs font-bold px-2 py-0.5">
                                    {user.code}
                                </span>
                            </td>

                            {/* Documento (EPP button) */}
                            <td className={`${tdBase} text-center`}>
                                <button
                                    type="button"
                                    onClick={() => addPpe(user)}
                                    className="inline-flex items-center gap-1 rounded-md border border-cyan-300 dark:border-cyan-700 text-cyan-700 dark:text-cyan-400 hover:bg-cyan-50 dark:hover:bg-cyan-900/20 text-xs font-medium px-2.5 py-1 transition-colors"
                                    title="Ver EPPs del empleado"
                                >
                                    <i className="fas fa-id-card"></i>
                                    {user.document}
                                </button>
                            </td>

                            {/* Nombres */}
                            <td className={tdBase}>
                                <div className="flex items-center gap-2.5">
                                    <div className="flex-shrink-0 h-8 w-8 rounded-full bg-blue-100 dark:bg-blue-900/40 flex items-center justify-center">
                                        <i className="fas fa-user text-blue-600 dark:text-blue-400 text-xs"></i>
                                    </div>
                                    <div>
                                        <p className="font-medium text-gray-900 dark:text-white">{user.first_name}</p>
                                        <p className="text-xs text-gray-400 dark:text-gray-500">{user.email}</p>
                                    </div>
                                </div>
                            </td>

                            {/* Apellidos */}
                            <td className={`${tdBase} text-gray-700 dark:text-gray-300 font-medium`}>
                                {user.last_name}
                            </td>

                            {/* Rol */}
                            <td className={`${tdBase} text-center`}>
                                <span className="inline-block rounded-full bg-blue-100 dark:bg-blue-900/40 text-blue-700 dark:text-blue-300 text-xs font-medium px-2.5 py-0.5">
                                    {user.role_name || "Sin rol"}
                                </span>
                            </td>

                            {/* Ruta principal */}
                            <td className={`${tdBase} text-center`}>
                                <span className="inline-block rounded-full bg-cyan-100 dark:bg-cyan-900/40 text-cyan-700 dark:text-cyan-300 text-xs font-medium px-2.5 py-0.5">
                                    {user.gang_name || "Sin ruta"}
                                </span>
                            </td>

                            {/* Rutas asignadas */}
                            <td className={`${tdBase} text-center`}>
                                {user.assigned_gangs && user.assigned_gangs.length > 0 ? (
                                    <div className="flex flex-wrap justify-center gap-1">
                                        {user.assigned_gangs.map((gang, i) => (
                                            <span
                                                key={gang.id || i}
                                                title={`${gang.name} - ${gang.warehouse_name}`}
                                                className="inline-flex items-center gap-1 rounded-full bg-emerald-100 dark:bg-emerald-900/40 text-emerald-700 dark:text-emerald-300 text-xs font-medium px-2 py-0.5"
                                            >
                                                <i className="fas fa-route text-[10px]"></i>
                                                {gang.name}
                                            </span>
                                        ))}
                                    </div>
                                ) : (
                                    <span className="text-xs text-gray-400 dark:text-gray-500">Sin asignar</span>
                                )}
                            </td>

                            {/* Super usuario */}
                            <td className={`${tdBase} text-center`}>
                                {user.is_superuser ? (
                                    <span className="inline-flex items-center gap-1 rounded-full bg-amber-100 dark:bg-amber-900/40 text-amber-700 dark:text-amber-300 text-xs font-medium px-2.5 py-0.5">
                                        <i className="fas fa-crown text-[10px]"></i>Sí
                                    </span>
                                ) : (
                                    <span className="text-xs text-gray-400 dark:text-gray-500">No</span>
                                )}
                            </td>

                            {/* Estado */}
                            <td className={`${tdBase} text-center`}>
                                {user.is_active ? (
                                    <span className="inline-flex items-center gap-1 rounded-full bg-emerald-100 dark:bg-emerald-900/40 text-emerald-700 dark:text-emerald-300 text-xs font-medium px-2.5 py-0.5">
                                        <span className="h-1.5 w-1.5 rounded-full bg-emerald-500"></span>Activo
                                    </span>
                                ) : (
                                    <span className="inline-flex items-center gap-1 rounded-full bg-red-100 dark:bg-red-900/40 text-red-700 dark:text-red-300 text-xs font-medium px-2.5 py-0.5">
                                        <span className="h-1.5 w-1.5 rounded-full bg-red-500"></span>Inactivo
                                    </span>
                                )}
                            </td>

                            {/* Celular */}
                            <td className={`${tdBase} text-center text-gray-600 dark:text-gray-400`}>
                                {user.phone || <span className="text-gray-300 dark:text-gray-600">—</span>}
                            </td>
                            
                            {/* Acciones */}
                            <td className={`${tdBase} text-center`}>
                                <div className="flex items-center justify-center gap-1.5">
                                    <button
                                        type="button"
                                        onClick={() => updateUser(user)}
                                        title="Editar empleado"
                                        className="inline-flex items-center gap-1 rounded-md border border-blue-300 dark:border-blue-700 text-blue-600 dark:text-blue-400 hover:bg-blue-50 dark:hover:bg-blue-900/20 text-xs font-medium px-2.5 py-1 transition-colors"
                                    >
                                        <i className="fas fa-edit"></i>
                                        Editar
                                    </button>
                                    <button
                                        type="button"
                                        onClick={() => onDeleteUser(user)}
                                        title="Eliminar empleado"
                                        className="inline-flex items-center gap-1 rounded-md border border-red-300 dark:border-red-700 text-red-600 dark:text-red-400 hover:bg-red-50 dark:hover:bg-red-900/20 text-xs font-medium px-2.5 py-1 transition-colors"
                                    >
                                        <i className="fas fa-trash"></i>
                                        Eliminar
                                    </button>
                                </div>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
}
